/**
 * @public
 * Sums all the values in an array by reducing it.
 *
 * @see https://gist.github.com/jherax/a9846d44b62b64d7a182d6d6ec9de526
 *
 * @param  {Array} array: the collection to iterate.
 * @param  {String|Number} prop: (optional) property name or array index.
 * @return {Number}
 */
export default function sumValues(array, prop) {
  if (!array || !array.length) return 0;
  if ((/string|number/).test(typeof prop)) {
    return array.reduce((total, cv) => total + (+cv[prop]), 0);
  }
  return array.reduce((total, cv) => total + (+cv), 0);
}
